import React from "react";

import { times } from "lodash-es";

import { Skeleton } from "src/design-system/Skeleton";

export const AgentTraceSkeleton: React.FC = () => (
  <div className="space-y-3">
    {/* Agent input accordion skeleton */}
    <div className="rounded-lg border border-gray-200">
      <div className="flex items-center gap-2 px-3 py-2.5">
        <Skeleton height="h-4" width="w-4" />
        <Skeleton height="h-4" width="w-24" />
      </div>
      <div className="space-y-2 px-3 pb-3">
        <div className="rounded-lg bg-gray-50 px-4 py-3">
          <Skeleton height="h-3" width="w-full" />
          <div className="mt-1.5">
            <Skeleton height="h-3" width="w-3/4" />
          </div>
          <div className="mt-1.5">
            <Skeleton height="h-3" width="w-1/2" />
          </div>
        </div>
      </div>
    </div>
    {/* AI text skeleton */}
    <div className="space-y-1.5">
      <Skeleton height="h-3" width="w-full" />
      <Skeleton height="h-3" width="w-5/6" />
    </div>
    {/* Tool call skeletons */}
    {times(3, (i) => (
      <div key={i} className="rounded-lg border border-gray-200">
        <div className="flex items-center gap-2 px-3 py-2.5">
          <Skeleton height="h-4" width="w-4" />
          <Skeleton height="h-5" rounded="rounded-lg" width="w-5" />
          <Skeleton height="h-4" width="w-32" />
          <div className="ml-auto flex items-center gap-1.5">
            <Skeleton height="h-5" width="w-12" />
            <Skeleton height="h-5" width="w-12" />
            <Skeleton height="h-5" width="w-16" />
          </div>
        </div>
      </div>
    ))}
    {/* More AI text skeleton */}
    <div className="space-y-1.5">
      <Skeleton height="h-3" width="w-full" />
      <Skeleton height="h-3" width="w-4/6" />
    </div>
  </div>
);
